import { get, put, post } from '../coreservices/apiService'
import * as environment from '../env_config/environment'

export function get_userLogin(userName, password) {
    let apiUrl = environment.apiUrl;
    let url = `${apiUrl}/YES/userLogin/${userName}/${password}`
    return get(url).then(response => {
        return response;
    })
}

export function GetDashboardDetails(iActive, userName, assessment) {
    let apiUrl = environment.apiUrl;
    let url = `${apiUrl}/YES/GetDashboardDetails/${iActive}/${userName}/${assessment}`
    return get(url).then(response => {
        return response;
    })
}

export function Get_AssessmentData_by_Method(method, language, username, assessmentId) {
    let apiUrl = environment.apiUrl;
    let url = `${apiUrl}/YES/Get_AssessmentData_by_Method/${method}/${language}/${username}/${assessmentId}`
    return get(url).then(response => {
        return response;
    })
}

export function GetCombinedAssessmentResults(method, language, userId, assessmentId) {
    let apiUrl = environment.apiUrl;
    let url = `${apiUrl}/YES/GetCombinedAssessmentResults/${method}/${language}/${userId}/${assessmentId}`
    return get(url).then(response => {
        return response;
    })
}

export function GetChoicesByQID(iActive, QId, Assessmentid, UserName, language) {
    let apiUrl = environment.apiUrl;
    let url = `${apiUrl}/YES/GetChoicesByQID/${iActive}/${QId}/${Assessmentid}/${UserName}/${language}`
    return get(url).then(response => {
        return response;
    })
}

export function post_InsertAnswer(data) {
    let apiUrl = environment.apiUrl;
    let url = `${apiUrl}/YES/InsertAnswer`
    return post(url, data).then(response => {
        return response;
    })
}

// Add this to your services/csaApi.js or similar file
export const sendAttachments = async (fileData) => {
    let apiUrl = environment.apiUrl;
    const formData = new FormData();
    formData.append('file', fileData.file);
    formData.append('qid', fileData.qid);
    formData.append('index', fileData.index);
    formData.append('assessmentId', localStorage.getItem("AssessmentId"));
    formData.append('userName', localStorage.getItem("userName"));
    formData.append('uid', localStorage.getItem("uId"));
    formData.append('gid', fileData.gid);

    try {
        const response = await fetch(`${apiUrl}/YES/UploadAttachment`, {
            method: 'POST',
            body: formData,
            // Don't set Content-Type header, let the browser set it with boundary
        });
        return await response.json();
    } catch (error) {
        console.error('Error uploading attachment:', error);
        throw error;
    }
};

export function DeleteAttachment(data) {
    let apiUrl = environment.apiUrl;
    let url = `${apiUrl}/YES/DeleteAttachment`
    return post(url, data).then(response => {
        return response;
    })
}

export function GetAnswerData(userId, assessmentId, gid) {
    let apiUrl = environment.apiUrl;
    let url = `${apiUrl}/YES/GetAnswerData/${userId}/${assessmentId}/${gid}`
    return get(url).then(response => {
        return response;
    })
}

export function getAssessmentData(userId, assessmentId) {
    let apiUrl = environment.apiUrl;
    let url = `${apiUrl}/YES/getAssessmentData/${userId}/${assessmentId}`
    return get(url).then(response => {
        return response;
    })
}

// export function fetchAttachmentsForQuestion(userId, assessmentId, qid) {
//     let apiUrl = environment.apiUrl;
//     let url = `${apiUrl}/YES/GetAttachmentsByUIDAIDQID/${userId}/${assessmentId}/${qid}`
//     return get(url).then(response => {
//         return response;
//     })
// }

export function fetchAttachmentsForQuestiongid(userId, assessmentId, gid) {
    let apiUrl = environment.apiUrl;
    let url = `${apiUrl}/YES/GetAttachmentsByUIDAIDGID/${userId}/${assessmentId}/${gid}`
    return get(url).then(response => {
        return response;
    })
}

export function opportunityBubbleChart(userId, AssesmentID, mid, eid, lid) {
    let apiUrl = environment.apiUrl;
    let url = `${apiUrl}/YES/OpportunityBubbleChart/${userId}/${AssesmentID}/${mid}/${eid}/${lid}`
    return get(url).then(response => {
        return response;
    })
}

export function UserMaster_SelectAll() {
    let apiUrl = environment.apiUrl;
    let url = `${apiUrl}/YES/UserMaster_SelectAll`
    return get(url).then(response => {
        return response;
    })
}

export function updateOpportunityData(payload) {
    let apiUrl = environment.apiUrl;
    let url = `${apiUrl}/YES/BubbleChart_SAVE`;

    return post(url, payload).then(response => {
        return response;
    });
}

export function CopyReviewAssessment(payload) {
    let apiUrl = environment.apiUrl;
    let url = `${apiUrl}/YES/CopyReviewAssessment`;

    return post(url, payload).then(response => {
        return response;
    });
}

export function deleteAnswerDataCopy(payload) {
    let apiUrl = environment.apiUrl;
    let url = `${apiUrl}/YES/DeleteAnswerDataCopy`;

    return post(url, payload).then(response => {
        return response;
    });
}


export function updateOpportunityDataSingle(payload) {
    let apiUrl = environment.apiUrl;
    let url = `${apiUrl}/YES/SaveBubbleChartSingle`;

    return post(url, payload).then(response => {
        return response;
    });
}


export function download_updated_excel(userName, AssessmentId) {
    let apiUrl = environment.apiUrl;
    let url = `${apiUrl}/YES/download_updated_excel/${userName}/${AssessmentId}`
    // return get(url).then(response => {
    //     return response;
    // })
     return fetch(url, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        },
    })
    .then(response => {
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        return response.blob(); // Return the blob directly
    });
}